let script = null;

const loadScript = (url, callback) => {
  if (script) {
    if (window.google) {
      callback();
    } else {
      window.setTimeout(() => loadScript(url, callback), 500);
    }
  } else {
    script = document.createElement('script');
    script.type = 'text/javascript';

    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = () => callback();
    }
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  }
};

export default loadScript;
